<template>
  <div class="q-container"
       :style="{ margin: `0 ${containerMargin}rem 1rem` }"
       @click="$router.push(`/journey/${id}`)">
    <div class="q-number-container"
         :style="{ backgroundColor: backgroundColorL }">
        <p class="sub-header">คิวที่</p>
        <q-number :q-number="qNumber"
                  :q-prefix="qPrefix"
                  :q-suffix="qSuffix"
                  color="#454545">
        </q-number>
        <span v-if="appointTime"
              class="mdi mdi-clock-outline time">
          {{ epochToStr(appointTime, 'HH:mm') }}
        </span>
    </div>
    <div class="q-description">
      <p class="service-unit">
        <img class="service-unit-icon" :src="require(`@/assets/img/${serviceUnitIcon}`)" />&nbsp;
        {{ serviceUnitName }}:
        <span v-if="serviceType !== 'examination'">{{ qType }}</span>
      </p>
      <p class="location">{{ location }}</p>
      <p class="case-description"
         :style="{ color: caseTextColor }">
         {{ caseMessage }}
      </p>
    </div>
    <div class="flex flex-column justify-center"
        style="margin-left: auto;"
        :style="{ marginRight: `${arrowMarginRight}px` }">
      <span class="mdi mdi-chevron-right icon-scale bigger arrow"></span>
    </div>
  </div>
</template>

<script>
import statusColorMixin from '../mixins/statusColor.js'
import QNumber from '../components/qNumber'
import screenMixin from '../mixins/screen.js'

const props = {
  id: {
    type: String,
    required: true
  },
  serviceType: {
    type: String,
    required: true
  },
  qNumber: {
    type: String,
    default: ''
  },
  qPrefix: {
    type: String,
    default: ''
  },
  qSuffix: {
    type: String,
    default: ''
  },
  qType: {
    type: String
  },
  serviceUnitName: {
    type: String,
    required: true
  },
  location: {
    type: String,
    required: true
  },
  appointTime: {
    type: Number
  },
  caseNumber: {
    type: Number,
    required: true
  },
  caseStatus: {
    type: String,
    required: true
  },
  caseMessage: {
    type: String,
    required: true
  },
  caseDescription: {
    type: String,
    required: false
  },
  backgroundColor: {
    type: String
  },
  textColor: {
    type: String
  }
}

export default {
  name: 'qCardOverview',
  props,
  mixins: [statusColorMixin, screenMixin],
  components: {
    QNumber
  },
  computed: {
    containerMargin () {
      if (this.screenWidth <= 340) {
        return 1
      } else {
        return 0
      }
    },
    arrowMarginRight () {
      if (this.screenWidth <= 340) {
        return 8
      } else {
        return 0
      }
    },
    serviceUnitIcon () {
      switch (this.serviceType) {
        case 'examination':
          return 'examination.png'
        case 'registration':
          return 'user-edit.png'
        case 'pharmacy':
          return 'medicine.png'
        case 'cashier':
          return 'money.png'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.q-container {
  display: flex;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  min-height: 90px;

  .q-number-container {
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 88px;

    .sub-header {
      font-family: 'Mitr', sans-serif;
      font-size: .6875rem;
      text-align: center;
    }

    .time {
      color: #6e6e6e;
      font-size: .75rem;
      font-family: 'Prajad', sans-serif;
      font-weight: bold;
      text-align: center;
    }
  }

  .q-description {
    padding: 1rem;
    font-family: 'Prajad', sans-serif;
    max-width: 225px;
    display: flex;
    flex-direction: column;

    .service-unit {
      font-size: 1rem;
      font-weight: bold;
      color: #454545;

      .service-unit-icon {
        width: 20px;
        height: 20px;
        float: left;
      }
    }

    .location {
      font-weight: bold;
      font-size: .75rem;
    }

    .case-description {
      font-size: .875rem;
      font-weight: bold;
      margin-top: auto;
    }
  }

  .arrow {
    color: #707070;
  }
}
</style>
